import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ResetPasswordReducer from "./auth/resetpwd/reducer";

// Dashboard
import Dashboard from "./dashboard/reducer";

// Search
import SearchReducer from "./search/reducer";

// LOA
import LOAReducer from "./loa/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: Dashboard,
  Search: SearchReducer,
  ResetPassword: ResetPasswordReducer,
  LOA: LOAReducer,
});

export default rootReducer;
